import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { errorHandler, successHandler } from 'utils/errorHandler';


export const setHomePageOfUser = createAsyncThunk(
    'setHomePageOfUser',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.post(
                `${API_URL.setHomePage}`,
                { ...data, email },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 1,
                },
            );
            successHandler(dispatch, response.response);
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

